export default "__VITE_ASSET__BRc18EtG__"